<template>
	<div class="pickList-container">
		<div :style="isVertical ? 'width:720px' : 'width:1020px'">
			<div class="print-btn-box">
				<i class="el-icon-back" @click="goBack"></i>
				打印方向：
				<el-radio v-model="isVertical" :label="true" @change="printTypeChange">纵向</el-radio>
				<el-radio v-model="isVertical" :label="false" @change="printTypeChange">横向</el-radio>
				<el-button v-print="print" size="mini" plain type="primary">打印</el-button>
			</div>
			<div id="printArea">
				<div v-show="showType === 0" v-for="(printItem, index) in printTitleArr" :key="showType + '-' + index">
					<el-table
						ref='table'
						class="grid-content"
						:data="tableData"
						@header-dragend="headerDrag"
						border
						size='mini'>
						<el-table-column
							:resizable="false"
							prop="pro_bcName"
							v-if='showBig'
							label="店铺级大类"
							align='center'
							width="100"
							>
						</el-table-column>
						<el-table-column
							:resizable="false"
							prop="pro_scName"
							v-if='showSmall&& bigcategoryview ===1'
							label="店铺级小类"
							align='center'
							width="100"
							>
						</el-table-column>
						<el-table-column
							:resizable="false"
							prop="pro_pName"
							label="商品"
							align='center'
							width="100"
							>
						</el-table-column>
						<el-table-column
							:resizable="false"
							prop="pro_pUnit"
							label="规格"
							align='center'
							width="100"
							>
						</el-table-column>
						<el-table-column
							v-if='showTotal'
							:resizable="false"
							prop="pro_sumTotalCnt"
							label="总计"
							align='center'
							width="100"
							>
						</el-table-column>
						<el-table-column v-for='(item,index) in printItem' align='center' :key='index' :label="item.name">
							<el-table-column v-for='(item1,index1) in item.arr' :width='item1.width' :prop="item1.key" align='center' :key='index1' :label="item1.name">
								<el-table-column
									v-for='(item2,index2) in item1.arr' :key='index2'
									:prop="item2.key"
									:label="item2.name"
									align='center'
									:width='item2.width'
								>
								</el-table-column>
							</el-table-column>
						</el-table-column>
					</el-table>
					<div style="break-before: page"></div>
				</div>
				<div v-show='showType === 1' v-for="(printItem, printIndex) in printTitleArr" :key="showType + 'a' + printIndex">
					<el-table
						v-if='showBig && showSmall && bigcategoryview === 1'
						ref='table'
						class="grid-content"
						@header-dragend="headerDrag"
						:data="tableData"
						border
						size='mini'>
						<el-table-column label="店铺级大类" align='center'>
							<el-table-column label="店铺级小类" align='center'>
								<el-table-column
									prop="cus_cusName"
									:resizable="false"
									label="客户"
									align='center'
									width="100">
								</el-table-column>
								<el-table-column
									v-if='showTotal'
									prop="cus_sumTotalCnt"
									:resizable="false"
									label="总计"
									align='center'
									width="100">
								</el-table-column>
							</el-table-column>
						</el-table-column>
						<el-table-column v-for='(item,index) in printItem' align='center' :key='printIndex + "-s" + index' :label="item.pro_bcName">
							<el-table-column align='center' :label="item.pro_scName">
								<el-table-column align='center' :label="item.pro_pName">
									<el-table-column
										v-for='(item1) in item.arr' :key='item1.key'
										:prop="item1.key"
										:label="item1.name"
										align='center'
										:width='item1.width'
									>
									</el-table-column>
								</el-table-column>
							</el-table-column>
						</el-table-column>
					</el-table>
					<el-table
						v-if='!showBig && showSmall && bigcategoryview === 1'
						ref='table'
						class="grid-content"
						@header-dragend="headerDrag"
						:data="tableData"
						border
						size='mini'>
						<el-table-column label="店铺级小类" align='center'>
							<el-table-column
								:resizable="false"
								prop="cus_cusName"
								label="客户"
								align='center'
								width="100">
							</el-table-column>
							<el-table-column
								:resizable="false"
								v-if='showTotal'
								prop="cus_sumTotalCnt"
								label="总计"
								align='center'
								width="100">
							</el-table-column>
						</el-table-column>
						<el-table-column v-for='(item,index) in printItem' align='center' :key='printIndex + "-s" + index' :label="item.pro_scName">
							<el-table-column align='center' :label="item.pro_pName">
								<el-table-column
									v-for='(item1) in item.arr' :key='item1.key'
									:prop="item1.key"
									:label="item1.name"
									align='center'
									:width='item1.width'
								>
								</el-table-column>
							</el-table-column>
						</el-table-column>
					</el-table>
					<el-table
						v-if='showBig && !(showSmall && bigcategoryview === 1)'
						ref='table'
						@header-dragend="headerDrag"
						class="grid-content"
						:data="tableData"
						border
						size='mini'>
						<el-table-column label="店铺级大类" align='center'>
							<el-table-column
								:resizable="false"
								prop="cus_cusName"
								label="客户"
								align='center'
								width="100">
							</el-table-column>
							<el-table-column
								v-if='showTotal'
								:resizable="false"
								prop="cus_sumTotalCnt"
								label="总计"
								align='center'
								width="100">
							</el-table-column>
						</el-table-column>
						<el-table-column v-for='(item,index) in printItem' align='center' :key='printIndex + "-s" + index' :label="item.pro_bcName">
							<el-table-column align='center' :label="item.pro_pName">
								<el-table-column
									v-for='(item1) in item.arr' :key='item1.key'
									:prop="item1.key"
									:label="item1.name"
									align='center'
									:width='item1.width'
								>
								</el-table-column>
							</el-table-column>
						</el-table-column>
					</el-table>
					<el-table
						v-if='!showBig && !(showSmall && bigcategoryview === 1)'
						ref='table'
						class="grid-content"
						@header-dragend="headerDrag"
						:data="tableData"
						border
						size='mini'>
						<el-table-column
							:resizable="false"
							prop="cus_cusName"
							label="客户"
							align='center'
							width="100">
						</el-table-column>
						<el-table-column
							:resizable="false"
							v-if='showTotal'
							prop="cus_sumTotalCnt"
							label="总计"
							align='center'
							width="100">
						</el-table-column>
						<el-table-column v-for='(item,index) in printItem' align='center' :key='printIndex + "-s" + index' :label="item.pro_pName">
							<el-table-column
								v-for='(item1) in item.arr' :key='item1.key'
								:prop="item1.key"
								:label="item1.name"
								align='center'
								:width='item1.width'
							>
							</el-table-column>
						</el-table-column>
					</el-table>
					<div style="break-before: page"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import print from 'vue-print-nb'
export default {
	name: 'categoryLists',
	data () {
		return {
			print: {
				id: 'printArea',
				popTitle: '',
				extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style>  #printArea {  100%;  } <style>'
			},
			showType: null,
			showTotal: false,
			showLineTotal: false,
			showSmallTotal: false,
			showOrder: false,
			bigcategoryview: null,
			showBig: true,
			showSmall: true,
			proList: [],
			tableData: [],
			printTitleArr: [],
			allTitle: [],
			isVertical: true
		}
	},
	directives: {
		print
	},
	created () {
		var data = window.sessionStorage.getItem('pickListData')
		var params = JSON.parse(data)
		this.init(params)
	},
	methods: {
		goBack () {
			this.$router.push('/main/pickListTable')
		},
		printTypeChange () {
			this.initTitle(this.allTitle)
		},
		headerDrag (newWidth, oldWidth, column, event) {
			let key = column.property
			this.allTitle.find(item => {
				if (item.key === key) {
					item.width = newWidth
				}
			})
			this.initTitle(this.allTitle)
		},
		getPrintTitle (data) {
			let arr = []
			data.forEach(item => {
				item.arr.forEach(cusItem => {
					if (cusItem.arr) {
						arr = [...arr, ...cusItem.arr]
					} else {
						arr.push(cusItem)
					}
				})
			})
			this.allTitle = arr
			this.initTitle(arr)
		},
		initTitle (arr) {
			let num = 0
			let numArr = []
			let titleArr = []
			let printTitleArr = []
			let width = 0
			let maxWidth = this.isVertical ? 700 : 1000
			if (this.showType === 0) {
				width = 300
				if (this.showBig) {
					width += 100
				}
				if (this.showSmall && this.bigcategoryview === 1) {
					width += 100
				}
			} else {
				width = 100
				if (this.showTotal) {
					width += 100
				}
			}
			for (let i = 1; i < arr.length + 1; i++) {
				if ((arr[i - 1].width) > (maxWidth - width)) {
					arr[i - 1].width = (maxWidth - width)
				}
				num = num + (+arr[i - 1].width)
				if (num > (maxWidth - width)) {
					i--
					numArr.push(i)
					num = 0
				}
			}
			if (numArr.indexOf(arr.length) === -1) {
				numArr.push(arr.length)
			}
			for (let i = 0; i < numArr.length; i++) {
				if (i === 0) {
					let row = arr.slice(0, numArr[i])
					titleArr.push(row)
				} else {
					let row = arr.slice(numArr[i - 1], numArr[i])
					titleArr.push(row)
				}
			}
			titleArr.forEach(item => {
				if (this.showType === 0) {
					printTitleArr.push(this.initPrintTitle(item))
				} else {
					printTitleArr.push(this.initPrintTitle1(item))
				}
			})
			this.printTitleArr = printTitleArr
		},
		initPrintTitle1 (data) {
			let arr = []
			data.forEach(item => {
				let lineIndex = arr.findIndex(findItem => findItem.pro_pName === item.pro_pName)
				if (lineIndex === -1) {
					var row = {
						pro_pName: item.pro_pName,
						pro_bcName: item.pro_bcName,
						pro_scName: item.pro_scName,
						arr: [item]
					}
					arr.push(row)
				} else {
					arr[lineIndex].arr.push(item)
				}
			})
			return arr
		},
		initPrintTitle (data) {
			let arr = []
			data.forEach((item, index) => {
				let lineIndex = arr.findIndex(findItem => findItem.key === item.lineId)
				if (lineIndex === -1) {
					if (item.level === 2) {
						let row = {
							name: item.lineName,
							key: item.lineId,
							arr: [
								{
									name: item.name,
									key: item.key,
									width: item.width,
									num: item.num
								}
							]
						}
						arr.push(row)
					} else {
						let row = {
							name: item.lineName,
							key: item.lineId,
							arr: [
								{
									name: item.cusName,
									key: item.cusId,
									arr: [
										{
											name: item.name,
											key: item.key,
											width: item.width,
											num: item.num
										}
									]
								}
							]
						}
						arr.push(row)
					}
				} else {
					let cusIndex = arr[lineIndex].arr.findIndex(findCusItem => findCusItem.key === item.cusId)
					if (cusIndex === -1) {
						let row = {
							name: item.cusName,
							key: item.cusId,
							arr: [
								{
									name: item.name,
									key: item.key,
									width: item.width,
									num: item.num
								}
							]
						}
						arr[lineIndex].arr.push(row)
					} else {
						let row = {
							name: item.name,
							key: item.key,
							width: item.width,
							num: item.num
						}
						arr[lineIndex].arr[cusIndex].arr.push(row)
					}
				}
			})
			return arr
		},
		initTitleData (data) {
			var arr = []
			let num = 0
			for (var i = 0; i < data.length; i++) {
				num++
				var row = {
					name: data[i].orderLine,
					arr: []
				}
				if (this.showLineTotal) {
					row.arr.push({
						name: '线路小计',
						key: data[i].lineId + '-Total',
						lineId: data[i].lineId,
						lineName: data[i].orderLine,
						width: '100',
						level: 2,
						num: num
					})
				}
				if (this.showSmallTotal || this.showOrder) {
					for (var z = 0; z < data[i].cus.length; z++) {
						var cusRow = {
							name: data[i].cus[z].cusName,
							arr: []
						}
						if (this.showSmallTotal) {
							num++
							cusRow.arr.push({
								name: '小计',
								key: data[i].lineId + '-' + data[i].cus[z].cusSyscodeId + '-total',
								lineId: data[i].lineId,
								lineName: data[i].orderLine,
								cusId: data[i].cus[z].cusSyscodeId,
								cusName: data[i].cus[z].cusName,
								width: '100',
								level: 3,
								num: num
							})
						}
						if (this.showOrder) {
							for (var j = 0; j < data[i].cus[z].order.length; j++) {
								num++
								var orderRow = {
									name: data[i].cus[z].order[j].orderNumber,
									orderSource: data[i].cus[z].order[j].orderSource,
									key: data[i].lineId + '-' + data[i].cus[z].cusSyscodeId + '-' + data[i].cus[z].order[j].orderNumber,
									width: '100',
									lineId: data[i].lineId,
									lineName: data[i].orderLine,
									cusId: data[i].cus[z].cusSyscodeId,
									cusName: data[i].cus[z].cusName,
									level: 3,
									num
								}
								cusRow.arr.push(orderRow)
							}
						}
						row.arr.push(cusRow)
					}
				}
				arr.push(row)
			}
			this.getPrintTitle(arr)
		},
		initData (data) {
			var dataArr = []
			for (var i = 0; i < data.length; i++) {
				var dataRow = {
					pro_bcName: data[i].pro_bcName,
					pro_scName: data[i].pro_scName,
					pro_sumTotalCnt: data[i].pro_sumTotalCnt,
					pro_pUnit: data[i].pro_pUnit,
					pro_pName: data[i].pro_pName
				}
				for (var j = 0; j < data[i].line.length; j++) {
					dataRow[data[i].line[j].lineId + '-Total'] = data[i].line[j].totalCnt
					for (var z = 0; z < data[i].line[j].cus.length; z++) {
						dataRow[data[i].line[j].lineId + '-' + data[i].line[j].cus[z].cusSyscodeId + '-total'] = data[i].line[j].cus[z].totalCnt === 0 ? '' : data[i].line[j].cus[z].totalCnt
						for (var k = 0; k < data[i].line[j].cus[z].order.length; k++) {
							dataRow[data[i].line[j].lineId + '-' + data[i].line[j].cus[z].cusSyscodeId + '-' + data[i].line[j].cus[z].order[k].orderNumber] = data[i].line[j].cus[z].order[k].sendQuantity === 0 ? '' : data[i].line[j].cus[z].order[k].sendQuantity
						}
					}
				}
				dataArr.push(dataRow)
			}
			this.tableData = dataArr
		},
		init (data) {
			this.bigcategoryview = data.bigcategoryview
			this.showType = data.showType
			this.showBig = data.showBig === 1
			this.showSmall = data.showSmall === 1
			var list = data.showContent
			for (var i = 0; i < list.length; i++) {
				if (list[i] === 0) {
					this.showTotal = true
				}
				if (list[i] === 1) {
					this.showSmallTotal = true
				}
				if (list[i] === 2) {
					this.showOrder = true
				}
				if (list[i] === 3) {
					this.showLineTotal = true
				}
			}
			this.getList()
		},
		getList () {
			var data = window.sessionStorage.getItem('pickListData')
			var params = JSON.parse(data)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/pickGoodsList`,
				data: params
			}).then(res => {
				if (res.result) {
					if (this.showType === 0) {
						this.initTitleData(res.data.lineInfo)
						this.initData(res.data.proInfo)
					} else {
						if (this.showSmallTotal || this.showOrder) {
							this.initProData(res.data.proInfo)
						}
						this.initData1(res.data.lineInfo)
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initProData (data) {
			var arr = []
			for (var i = 0; i < data.length; i++) {
				var row = {
					pro_pName: data[i].cus_pro_pName,
					pro_bcName: data[i].cus_pro_bcName,
					pro_scName: data[i].cus_pro_scName,
					arr: []
				}
				if (this.showSmallTotal) {
					row.arr.push({
						name: '小计',
						key: data[i].cus_pro_pName + '-total',
						width: '100',
						pro_pName: data[i].cus_pro_pName,
						pro_bcName: data[i].cus_pro_bcName,
						pro_scName: data[i].cus_pro_scName
					})
				}
				if (this.showOrder) {
					for (var j = 0; j < data[i].cus_pro_order.length; j++) {
						var orderRow = {
							name: data[i].cus_pro_order[j].orderNumber,
							orderSource: data[i].cus_pro_order[j].orderSource,
							key: data[i].cus_pro_pName + '-' + data[i].cus_pro_order[j].orderNumber,
							width: '100',
							pro_pName: data[i].cus_pro_pName,
							pro_bcName: data[i].cus_pro_bcName,
							pro_scName: data[i].cus_pro_scName
						}
						row.arr.push(orderRow)
					}
				}
				arr.push(row)
			}
			// this.proList = arr
			this.getPrintTitle(arr)
		},
		initData1 (data) {
			var dataArr = []
			for (var i = 0; i < data.length; i++) {
				for (var k = 0; k < data[i].cus.length; k++) {
					var dataRow = {
						cus_cusName: data[i].line_orderLine + ' - ' + data[i].cus[k].cusName,
						cus_sumTotalCnt: data[i].cus[k].cus_sumTotalCnt
					}
					for (var j = 0; j < data[i].cus[k].pro.length; j++) {
						for (var z = 0; z < data[i].cus[k].pro[j].order.length; z++) {
							dataRow[data[i].cus[k].pro[j].pName + '-total'] = data[i].cus[k].pro[j].totalCnt === 0 ? '' : data[i].cus[k].pro[j].totalCnt
							dataRow[data[i].cus[k].pro[j].pName + '-' + data[i].cus[k].pro[j].order[z].orderNumber] = data[i].cus[k].pro[j].order[z].sendQuantity === 0 ? '' : data[i].cus[k].pro[j].order[z].sendQuantity
						}
					}
					dataArr.push(dataRow)
				}
				if (this.showLineTotal) {
					var obj = data[i].pro
					var lineRow = {
						cus_cusName: data[i].line_orderLine + '小计',
						cus_sumTotalCnt: data[i].totalCnt
					}
					Object.keys(obj).forEach(function (key) {
						lineRow[key + '-total'] = obj[key]
					})
					dataArr.push(lineRow)
				}
			}
			this.tableData = dataArr
		}
	}
}
</script>
<style>
@media print {
/*最外层打印节点*/
  #printArea {
    display:block;
    height: auto;
    overflow: hidden;
  }
}
</style>
<style lang="stylus" scoped>
.pickList-container {
	margin 0 auto;
	overflow: auto
	.print-btn-box{
		display: flex;
		height: 60px;
		align-items: center;
		.el-icon-back{
			border-radius: 50%;
			cursor: pointer;
			background: #9da6af;
			padding: 3px;
			margin-right: 10px;
			&:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.table-box {
		padding-bottom: 10px
		margin-top :20px;
		overflow-y: auto;
		.grid-content {
			height 100%;
			table-layout: fixed
		}
	}
}
</style>
